import { createEvent, createStore } from 'effector'

export const openCarVehicleCategoryDrawer = createEvent()
export const closeCarVehicleCategoryDrawer = createEvent()

export const $isCarVehicleCategoryDrawerOpen = createStore<boolean>(false)
  .on(openCarVehicleCategoryDrawer, () => true)
  .on(closeCarVehicleCategoryDrawer, () => false)
